module.exports = __webpack_public_path__ + "static/media/accompany.cd2b0dc8.svg";